import { render } from "./BatchRenderer.vue?vue&type=template&id=50f8dde0&scoped=true"
import script from "./BatchRenderer.vue?vue&type=script&lang=js"
export * from "./BatchRenderer.vue?vue&type=script&lang=js"

import "./BatchRenderer.vue?vue&type=style&index=0&id=50f8dde0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f8dde0"]])

export default __exports__